import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import { extend } from 'flarum/common/extend';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import Stream from 'flarum/common/utils/Stream';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

const isLoading = Stream(false);


app.initializers.add('maisen20/update-ki-model', () => {
    extend(SessionDropdown.prototype, 'items', function(items) {
      const user = app.session.user;

      if (user && user.groups().some(group => group.id() === '1')) {
        items.add('update-ki-model',
            Button.component({
                className: 'Button',
                onclick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    sendPostRequest();
                },
                icon: isLoading() ? 'fa-spin fas fa-cog' : 'fas fa-cogs'  // Hier setzen Sie das Icon
            },
            [
              isLoading() ? ' KI-Model wird aktualisiert' : 'KI-Model aktualisieren'
            ])
        );
      }
    });
});

function sendPostRequest(e) {
    
    isLoading(true);
    m.redraw();  // fordert Mithril auf, die Ansicht neu zu zeichnen

    const token = app.session.csrfToken;

    fetch("/api/update-ki-model", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': token
        }
    }).then(response => response.json()).then(data => {
        isLoading(false);
        m.redraw();

        if(data.status !== undefined && data.status == "success") {
            alert('KI-Model wurde erfolgreich aktualisiert.');
        } else {
            alert('Fehler beim Aktualisieren des KI-Modells.');
        }
    }).catch(error => {
        isLoading(false);
        m.redraw();
        alert('Ein Fehler ist aufgetreten.');
    });
}